import React, { useMemo } from 'react';

import { MasterSlaApiResponse } from '../../types/api/MasterSlaApiType';
import { EstimateDetail } from '../../types/common/EstimateInquiryType';

type EditEstimateRowEditSlaProps = {
    rowID: string;
    estimatePatternRowNumber: number;
    masterSla: Array<MasterSlaApiResponse>;
    estimate: EstimateDetail;
    setStateEstimateDetail: (
        changeEstimateDetailData: EstimateDetail,
        changeEstimatePatternRowNumber: number
    ) => void;
    inputMode: boolean;
};

export const EditEstimateRowEditSla: React.FC<EditEstimateRowEditSlaProps> = ({
    estimatePatternRowNumber,
    masterSla,
    estimate,
    setStateEstimateDetail,
    inputMode,
}) => {
    // select 保守レベル
    const slaList: Array<MasterSlaApiResponse> = useMemo<Array<MasterSlaApiResponse>>(() => masterSla, []);

    return (
        <div className='edit-fields'>
            <div className='field-level'>
                <h3>保守レベル</h3>
                <div className='select'>
                    <select
                        value={estimate.maintenanceLevelCode}
                        onChange={(e) =>
                            setStateEstimateDetail(
                                { ...estimate, maintenanceLevelCode: e.target.value },
                                estimatePatternRowNumber
                            )
                        }
                        disabled={!inputMode}
                    >
                        {slaList.length > 0 &&
                            slaList.map((sla) => (
                                <option key={`bulk-sla-${sla.sla_id}`} value={`${sla.sla_id}`}>
                                    {sla.sla_name}
                                </option>
                            ))}
                    </select>
                </div>
            </div>
        </div>
    );
};
